import { z } from 'zod';
import { auctionsOfAuctionTileSortByValues } from 'src/apis/transport-auction/mappings';
import {
  ascSortDirectionSchema,
  getPaginationSchema,
} from 'src/components/form/zod-schemas';
import { preprocessAsBoolean } from 'src/components/form/zod-utilities';

export const auctionsParamsSchema = z
  .object({
    quickFilterId: z.string().nullable().default(null),
    favouritesOnly: z.preprocess(
      preprocessAsBoolean,
      z.boolean().nullable().default(null)
    ),
    sortBy: z
      .enum(auctionsOfAuctionTileSortByValues)
      .default('NETWORK_POINT_OR_BUNDLE_NAME'),
    sortDirection: ascSortDirectionSchema,
  })
  .merge(getPaginationSchema());
